import { MessageV2DTO, SenderEnvelopeDTO } from 'support/types';

export type DocumentDTO = MessageV2DTO | SenderEnvelopeDTO;

export enum WebEDISidebarTabs {
  OVERVIEW = 'overview',
  AGENTS = 'agents',
}

export enum WebEDIAgentsTabAvailability {
  ENABLED,
  DEFAULT,
  DISABLED,
  LOADING,
}
